var installedModules = {};
var moduleToHandlerMapping = {
	7082: {
		getter: () => (__webpack_require__.e(294).then(() => (() => (__webpack_require__(7294))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	5269: {
		getter: () => (__webpack_require__.e(294).then(() => (() => (__webpack_require__(7294))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">= 16.8.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	3188: {
		getter: () => (__webpack_require__.e(294).then(() => (() => (__webpack_require__(7294))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^16.0.0 || ^17.0.0 || ^18.0.0 || ^19.0.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	8437: {
		getter: () => (__webpack_require__.e(294).then(() => (() => (__webpack_require__(7294))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.3.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	9433: {
		getter: () => (Promise.all([__webpack_require__.e(935), __webpack_require__.e(604)]).then(() => (() => (__webpack_require__(3935))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^16.0.0 || ^17.0.0 || ^18.0.0 || ^19.0.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	2604: {
		getter: () => (__webpack_require__.e(294).then(() => (() => (__webpack_require__(7294))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.2.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	5098: {
		getter: () => (__webpack_require__.e(294).then(() => (() => (__webpack_require__(7294))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	4166: {
		getter: () => (Promise.all([__webpack_require__.e(610), __webpack_require__.e(1), __webpack_require__.e(269), __webpack_require__.e(689)]).then(() => (() => (__webpack_require__(1001))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.0.126",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@bwoty-web/ui-kit",
	},
	7222: {
		getter: () => (__webpack_require__.e(294).then(() => (() => (__webpack_require__(7294))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">=18.0.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"82": [
		7082
	],
	"98": [
		5098
	],
	"166": [
		4166
	],
	"222": [
		7222
	],
	"269": [
		5269
	],
	"604": [
		2604
	],
	"689": [
		3188,
		8437,
		9433
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}